import api from '@/store/modules/pgtcases/api'
import NotificationService from '@/services/notificationService'
import {UPDATE_SAMPLE_IN_CASE_AFTER_RESET_DUE_DAYS} from '@/store/modules/pgtcases/mutations/available'

export const resetSampleDueDaysCounter = async ({state, commit}, sampleId) => {
    let result = false

    try {
        result = await api.resetSampleDueDaysCounter(sampleId)

        commit(UPDATE_SAMPLE_IN_CASE_AFTER_RESET_DUE_DAYS, result)
    } catch (e) {
        NotificationService.error('Unable to reset due days counter. Try again later')
    }
    return result
}